import React, { Fragment, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountClientContactAsync, updateAccountClientContactAsync, resetSelectedRecordObjectInState } from "./ClientContactSlice";
import { ClientContactInitialsForAdd, ClientContactInitialsForUpdate } from "./interfaces/ClientContactClass";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { getValueFromResource } from "../../../common/timeLiveFunction";

export const ClientContactForm = (props: any) => {
    const { AccountPartyId } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(ClientContactInitialsForAdd);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.clientContact);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [selectedCountryOptionDropDown, setSelectedCountryOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    const [selectedDepartmentOptionDropDown, setSelectedDepartmentOptionDropDown] = useState<{ value: string; label: string } | null>(null);
    // const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [statusTypeArray, SetstatusTypeArray] = useState<any | ''>([]);
    const [departmentArray, setDepartmentArray] = useState<any | ''>([]);
    const [countryArray, SetCountryArray] = useState<any | ''>([]);
    const [tab, setTab] = useState('Basic');
    const { t } = useTranslation()
    const dispatch = useAppDispatch();
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const getCountriesAsync = async () => {
        const response = await fetchAPI("api/v2/ClientContacts/Countries", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        if (Object.keys(json.Data).length !== 0) {
            json.Data.map((item: any) => {
                item.value = item.CountryId;
                item.label = item.Country;
                delete item.CountryId;
                delete item.Country;
            });
            SetCountryArray(json.Data);
        }
    }
    const getClientDepartmentAsync = async () => {
        const response = await fetchAPI("api/v2/ClientContacts/Departments/" + AccountPartyId, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
console.log("Dep:",json.Data);
        if (Object.keys(json.Data).length !== 0) {
            json.Data.map((item: any) => {
                item.value = item.Id;
                item.label = item.Name;
                delete item.Id;
                delete item.Name;
            });
            setDepartmentArray(json.Data);
        }

    }

    useEffect(() => {
        getCountriesAsync();
        getClientDepartmentAsync();
    }, [])

    useEffect(() => {
        let stateItem: any = {}
        setTab('Basic')
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(ClientContactInitialsForUpdate).map((item) => {
                if (item === 'AccountPartyId') {
                    return stateItem[item] = AccountPartyId;
                }
                else {
                    return stateItem[item] = tempObj[item];
                }
            })
            setCurrentFieldsData(stateItem);
            setSelectedCountryOptionDropDown(countryArray.find((country: any) => country.value == stateItem.CountryId));
            setSelectedDepartmentOptionDropDown(departmentArray.find((department: any) => department.value == stateItem.AccountPartyDepartmentId));
            
        }
        else {
            //setSelectedOptionDropDown({ value: -1, label: '' });
            
            setCurrentFieldsData({...ClientContactInitialsForAdd,"AccountPartyId":AccountPartyId});
        }
    }, [selectedRecord])

    const handleTextChange = (e: any) => {
        setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) })
    }
    const handleChange = (data: any) => {

        const { value, label } = data;
        setSelectedOptionDropDown({ value: value, label: label });
        setCurrentFieldsData({ ...currentFieldsData, 'AccountExpenseTypeId': value });
    };
    const handleSubmit = (values: any) => {
        //e.preventDefault();
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountClientContactAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Client Contact Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    //   console.log('handleSubmit-updateAccountExpenseCategoryAsync-originalPromiseResult',originalPromiseResult);
                    //modelRef.current.click();
                }).catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    // console.log('handleSubmit-updateAccountExpenseCategoryAsync-rejectedValueOrSerializedError',rejectedValueOrSerializedError);
                })
        }
        else {

            dispatch(addAccountClientContactAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Client Contact Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                    // console.log('handleSubmit-addAccountExpenseCategoryAsync-originalPromiseResult',originalPromiseResult);
                    // modelRef.current.click();
                }).catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    ////console.log('handleSubmit-addAccountExpenseCategoryAsync-rejectedValueOrSerializedError',rejectedValueOrSerializedError);
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    AccountExpenseTypeId: selectedOptionDropDown?.value || "",
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}

                validationSchema={yup.object().shape({
                    FirstName: yup
                        .string()
                        .label('FirstName')
                        .trim()
                        .required('First Name is required'),
                    LastName: yup
                        .string()
                        .label('LastName')
                        .trim()
                        .required('Last Name is required')

                })}>
                {({ values, handleChange, setFieldValue, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className='card-body'>
                            <div className='row' >
                                <div className='card card-custom'>
                                    <div className='card-header card-header-stretch overflow-auto'>
                                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Basic' })}
                                                    onClick={() => setTab('Basic')}
                                                    role='tab'
                                                >
                                                    Basic
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Details' })}
                                                    onClick={() => setTab('Details')}
                                                    role='tab'
                                                >
                                                    Details
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <form className='form'>
                                        <div className='card-body'>
                                            {isLoading ?
                                                <div className="col-md-12">
                                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                                    </span>
                                                </div>
                                                : <>
                                                    <div className='tab-content pt-0'>
                                                        <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                                            <div className='row'>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">First Name</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='FirstName'
                                                                        name='FirstName'
                                                                        value={values.FirstName}
                                                                        onChange={handleChange('FirstName')}
                                                                        onBlur={() => setFieldTouched('FirstName')}
                                                                    />
                                                                    <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                                        {touched.FirstName && errors.FirstName &&
                                                                            <p className='errorMsg'>{errors.FirstName as string}</p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Last Name</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='LastName'
                                                                        name='LastName'
                                                                        value={values.LastName}
                                                                        onChange={handleChange('LastName')}
                                                                        onBlur={() => setFieldTouched('LastName')}
                                                                    />
                                                                    <div style={{ paddingRight: 0, paddingLeft: 0 }}>
                                                                        {touched.LastName && errors.LastName &&
                                                                            <p className='errorMsg'>{errors.LastName as string}</p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Email</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='EMailAddress'
                                                                        name='EMailAddress'
                                                                        value={values.EMailAddress}
                                                                        onChange={handleChange('EMailAddress')}
                                                                        onBlur={() => setFieldTouched('EMailAddress')}
                                                                    />
                                                                </div>

                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Country</label>
                                                                    <Select
                                                                        value={countryArray.find((option: any) => option.value == values.CountryId)}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        isSearchable={true}
                                                                        name="CountryId"
                                                                        onBlur={() => setFieldTouched('CountryId', true)}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange({
                                                                                target: {
                                                                                    id: "CountryId",
                                                                                    value: selectedOption?.value
                                                                                },
                                                                            });
                                                                        }}
                                                                        options={countryArray}
                                                                        styles={colourStyles}
                                                                    //isDisabled={Object.keys(selectedRecord).length > 0 ? true : false}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Department</label>
                                                                    <Select
                                                                        value={departmentArray.find((option: any) => option.value == values.AccountPartyDepartmentId)}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        isSearchable={true}
                                                                        name="AccountPartyDepartmentId"
                                                                        onBlur={() => setFieldTouched('AccountPartyDepartmentId', true)}
                                                                        onChange={(selectedOption) => {
                                                                            handleChange({
                                                                                target: {
                                                                                    id: "AccountPartyDepartmentId",
                                                                                    value: selectedOption?.value
                                                                                },
                                                                            });
                                                                        }}
                                                                        options={departmentArray}
                                                                        styles={colourStyles}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Location Contact</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Location'
                                                                        name="Location"
                                                                        value={values.Location}
                                                                        onChange={handleChange('Location')}
                                                                        onBlur={() => setFieldTouched('Location')}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className={clsx('tab-pane', { active: tab === 'Details' })}>
                                                            <div className='row'>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Address1</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Address1'
                                                                        name="Address1"
                                                                        value={values.Address1}
                                                                        onChange={handleChange('Address1')}
                                                                        onBlur={() => setFieldTouched('Address1')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Address2</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Address2'
                                                                        name="Address2"
                                                                        value={values.Address2}
                                                                        onChange={handleChange('Address2')}
                                                                        onBlur={() => setFieldTouched('Address2')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">State</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='State'
                                                                        name="State"
                                                                        value={values.State}
                                                                        onChange={handleChange('State')}
                                                                        onBlur={() => setFieldTouched('State')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">City</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='City'
                                                                        name="City"
                                                                        value={values.City}
                                                                        onChange={handleChange('City')}
                                                                        onBlur={() => setFieldTouched('City')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">
                                                                        {/* Telephone1 */}
                                                                        {getValueFromResource('Phone1',dispatch, t)}
                                                                    </label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Telephone1'
                                                                        name="Telephone1"
                                                                        value={values.Telephone1}
                                                                        onChange={handleChange('Telephone1')}
                                                                        onBlur={() => setFieldTouched('Telephone1')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">
                                                                        {/* Telephone2 */}
                                                                        {getValueFromResource('Phone2',dispatch, t)}
                                                                    </label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Telephone2'
                                                                        name="Telephone2"
                                                                        value={values.Telephone2}
                                                                        onChange={handleChange('Telephone2')}
                                                                        onBlur={() => setFieldTouched('Telephone2')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Fax</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Fax'
                                                                        name="Fax"
                                                                        value={values.Fax}
                                                                        onChange={handleChange('Fax')}
                                                                        onBlur={() => setFieldTouched('Fax')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="form-label">Zip Code</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        id='Zip'
                                                                        name="Zip"
                                                                        value={values.Zip}
                                                                        onChange={handleChange('Zip')}
                                                                        onBlur={() => setFieldTouched('Zip')}
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className='card-footer pt-4 '>
                            <div className='d-flex flex-stack float-end'>
                                <div className='d-flex align-items-center me-2'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-light btn-sm me-2"
                                        // data-bs-dismiss="modal"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                         {t('Cancel')}
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-light-primary btn-sm"
                                        onClick={() => handleSubmit()} disabled={!isValid}
                                        data-kt-element='send'
                                    >
                                        {Object.keys(selectedRecord).length > 0 ? 'Update' : 'Add'} Client Contact
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
